<template>
  <div class="bg-hahn-100 my-1 shadow-lg p-4 flex items-center border-l-4 justify-between relative" :class="{
                  'border-red-500': peer.wg_status.loss >= 95,
                  'border-orange-500': peer.wg_status.loss <= 94 && peer.wg_status.loss >= 20,
                  'border-green-500': peer.wg_status.loss <= 19,
              }">
    <div class="flex-1 pb-4">
      <h3 class="text-xl font-semibold">{{peer.device.name}}</h3>
      <p class="text-sm" :class="{
                  'text-red-500': peer.wg_status.loss >= 95,
                  'text-orange-500': peer.wg_status.loss <= 94 && peer.wg_status.loss >= 20,
                  'text-green-500': peer.wg_status.loss <= 19,
              }">Status: {{ peer.wg_status.loss <= 19 ? 'UP' : ((peer.wg_status.loss <= 94 && peer.wg_status.loss >= 20) ? 'DEGRADED' : 'DOWN') }}</p>
      <div v-if="expanded" class="py-2 text-sm">
        <h6 class="uppercase font-bold">Comments</h6>
        <pre v-if="expanded" class="px-2 border-l-gray border-l-1">{{peer.device.comments?.replaceAll("\\n","\n")}}</pre>
      </div>
      <div v-if="expanded" class="py-2 text-sm">
        <h6 class="uppercase font-bold">Statistics</h6>
        <p class="border-l-gray border-l-1 px-2" v-if="expanded">RTT: {{ peer.wg_status.rtt }}ms | Loss: {{peer.wg_status.loss}}%</p>
        <p class="border-l-gray border-l-1 px-2" v-if="expanded">System ID: {{ peer.device.id }} | IPv6: {{ peer.device.interfaces[0].ip_addresses[0].address }}</p>
        <p class="border-l-gray border-l-1 px-2" v-if="expanded">Transfer: {{ peer.wg_status.transfer }}</p>
        <p class="border-l-gray border-l-1 px-2" v-if="expanded && peer.wg_status?.latest_handshake">Latest Handshake: {{ peer.wg_status.latest_handshake }}</p>
      </div>
    </div>
    <div class="bg-hahn-dark-100 w-full h-5 text-sm absolute bottom-0 left-0 text-center cursor-pointer" @click="toggleExpand">
      {{ expanded ? "⮝" : "⮟"}}
    </div>
    <button class="bg-hahn-dark-100 uppercase text-white -mt-4 py-2 px-4 text-sm hover:bg-hahn-dark-200 cursor-pointer" @click="downloadConfig(peer.device.id)">
      Download
    </button>
  </div>
</template>

<script>
export default {
  name: 'PeerListEntry',
  props: ["peer", "expand"],
  data() {
    return {
      expanded: false,
      autoexpand: true,
    }
  },
  watch: {
    expand(newVal){
      if (newVal === true) {
        this.expanded = true
      }
      if (newVal === false && this.expanded) {
        this.expanded = false
      }
    }
  },
  methods: {
    toggleExpand() {
      this.expanded=!this.expanded
    },
    downloadConfig(deviceId) {
      const token = this.$keycloak.token;
      fetch(`/api/config/${deviceId}`, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(responseText => {
        const a = document.createElement('a');
        a.href = "data:text/plain;charset=utf-8," + encodeURIComponent(responseText);
        a.download = this.$props.peer.device.name + ".ovpn";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch(error => {
        console.error('There was an error with the fetch operation:', error);
      });
    }
  }
}
</script>